import type { ReactNode } from 'react';
import './Badge.css';

/**
 * Kleines Etikett in Pillenform. Laut Briefing ist die Pille (--radius-pill)
 * ausschliesslich fuer Marken/Etiketten erlaubt - dies ist so ein Etikett
 * (die Auszeichnung ueber der Startseiten-Ueberschrift), kein Bedienelement.
 */
export function Badge({ children }: { children: ReactNode }) {
  return <span className="badge">{children}</span>;
}
